
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


const NotFound = () => {
    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
            }}
        >
            <Typography variant='h1'>404</Typography>
            <Typography variant='h5'>Page Not Found</Typography>
        </Box>
    )
};

export default NotFound;
